import { Spinner } from '@va/icons';
import { useTranslate } from '@va/localization';
import { CustomDomainAction, CustomDomainContextMenu } from './CustomDomainContextMenu';
import { DomainItemContainer, DomainItemStatusBadge, DomainItemValue } from './DomainItem';
import { ProvisioningStep } from './ProvisioningSteps';
import { ProvisioningStepsTooltip } from './ProvisioningStepsTooltip';

export type DomainItemProps = {
  value: string;
  label: string;
  actions: CustomDomainAction[];
};

export const PendingDomainItem = ({
  label,
  actions,
  value,
  status,
  step,
  steps,
}: DomainItemProps & { status?: string; step?: string; steps?: ProvisioningStep[] }) => {
  const translate = useTranslate();
  const badge = (
    <DomainItemStatusBadge
      className='bg-[#5C00B8] text-white'
      label={translate('button.pending')}
      icon={<Spinner className='w-4 h-4' />}
    />
  );

  return (
    <DomainItemContainer>
      {step && status && steps ? (
        <ProvisioningStepsTooltip currentStepVal={step} status={status} steps={steps}>
          {badge}
        </ProvisioningStepsTooltip>
      ) : (
        badge
      )}

      <DomainItemValue label={label} value={value} />
      <div className='ml-auto'>
        <CustomDomainContextMenu actions={actions} />
      </div>
    </DomainItemContainer>
  );
};
